const ICON_SIZE_XS = "30px";
const ICON_SIZE_SM = "60px";
const ICON_SIZE_MD = "70px";
const ICON_SIZE_LG = "90px";
module.exports = (theme) => ({
  ".quick-links": {
    backgroundColor: theme("colors.primary.white"),
    padding: `${theme("spacing.2xl")} ${theme("spacing.lg")}`,
    margin: "auto",
    maxWidth: "1440px",
  },
  ".quick-links-content": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "auto",
  },
  [`.quick-links[items="4"] .quick-links-content`]: { maxWidth: "1320px" },
  [`.quick-links[items="3"] .quick-links-content`]: { maxWidth: "1074px" },
  [`.quick-links[items="2"] .quick-links-content`]: { maxWidth: "762px" },
  ".quick-links .quick-link": {
    alignItems: "center",
    backgroundColor: theme("colors.primary.white"),
    borderBottom: `1px solid ${theme("colors.background.blue")}`,
    display: "flex",
    flexDirection: "row",
    flex: "1 1 0",
    fontSize: theme("fontSize.xl"),
    fontWeight: theme("fontWeight.regular"),
    gap: theme("spacing.DEFAULT"),
    padding: `${theme("spacing.sm")} 0`,
    userSelect: "text",
  },
  ".quick-link .quick-link-icon": {
    background: "no-repeat center",
    backgroundSize: "contain",
    minHeight: ICON_SIZE_XS,
    minWidth: ICON_SIZE_XS,
    transform: "scale(1)",
  },
  ".quick-link .quick-link-text": { flexGrow: 1, overflowWrap: "anywhere" },
  ".quick-link .quick-link-icon-go": {
    height: "24px",
    marginRight: "-5px",
    transform: "scale(1)",
    width: "24px",
  },
  ".quick-links .quick-link .quick-link-text": {
    color: theme("colors.primary.black.DEFAULT"),
  },
  [`@media screen and (min-width: ${theme("screens.sm")})`]: {
    ".quick-links .quick-link": {
      fontSize: theme("fontSize.3xl"),
      gap: theme("spacing.xl"),
    },
    ".quick-link .quick-link-icon": { minHeight: ICON_SIZE_SM, minWidth: ICON_SIZE_SM },
  },
  [`@media screen and (min-width: ${theme("screens.md")})`]: {
    ".quick-links": {
      padding: `${theme("spacing.3xl")}`,
    },
    ".quick-links-content": {
      flexDirection: "row",
      gap: theme("spacing.lg"),
      justifyContent: "center",
    },
    ".quick-links .quick-link": {
      borderBottom: "none",
      flexDirection: "column",
      fontSize: "inherit",
      gap: theme("spacing.DEFAULT"),
      maxWidth: "400px",
      padding: `${theme("spacing.xl")} ${theme("spacing.xs")}`,
    },
    ".quick-links .quick-link:hover": { backgroundColor: theme("colors.background.blue") },
    ".quick-link .quick-link-icon": { minHeight: ICON_SIZE_MD, minWidth: ICON_SIZE_MD },
    ".quick-links .quick-link:hover .quick-link-text": {
      color: `${theme("colors.primary.blue.DEFAULT")}!important`,
    },
    ".quick-links .quick-link:active .quick-link-text": {
      color: `${theme("colors.secondary.darkblue.DEFAULT")}!important`,
    },
    ".quick-links .quick-link:hover .quick-link-text:before": {
      left: `${theme("spacing.sm")}`,
    },
  },
  [`@media screen and (min-width: ${theme("screens.lg")})`]: {
    ".quick-links .quick-link": { paddingLeft: theme("spacing.sm"), paddingRight: theme("spacing.sm") },
    ".quick-link .quick-link-icon": { minHeight: ICON_SIZE_LG, minWidth: ICON_SIZE_LG },
  },
});
